import React, { Component } from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
import { withStyles } from '@mui/styles';
import classnames from 'classnames';
import { string, object, bool, func, array } from 'prop-types';
import { textFieldStyles } from './inputStyles';

const styles = (theme) => ({
  ...textFieldStyles(theme),
  selectTaxRoot: {
    padding: `10px 10px`
  }
});

/**
 * Default validation rules:
    matchRegexp
    isEmail
    isEmpty
    required
    trim
    isNumber
    isFloat
    isPositive
    minNumber
    maxNumber
    minFloat
    maxFloat
    minStringLength
    maxStringLength
    isString
    maxFileSize
    allowedExtensions
    validators={['minNumber:0', 'maxNumber:255', 'matchRegexp:^[0-9]$']}
 */

/**
 * EXAMPLE HOW TO OVERRIDE THE TEXTFIELD BORDER AN FOCUS BORDER
 * TO replace border color it is only needed to pass notchedOutline class, to change the focus border
 * it is neede to pass the three of them
 * inputClasses={{
    root: classes.cssOutlinedInput,
    focused: classes.cssFocused,
    notchedOutline: classes.inputBorder
  }}

  inputBorder: {
    borderColor: `<color>`
  },
  cssOutlinedInput: {
    '&$cssFocused $inputBorder': {
      borderColor: `<color> !important`
    }
  },

  cssFocused: {}

 */
class TextField extends Component {
  render() {
    const {
      classes,
      className,
      readOnly,
      onEnterKey,
      inputProps,
      InputProps,
      inputClasses,
      validators,
      theme,
      inputLabelClasses,
      containerProps,
      classesProp,
      textFieldClassNames,
      style,
      variant,
      id,
      fullWidth,
      ...other
    } = this.props;

    return (
      <TextValidator
        id={id}
        fullWidth
        containerProps={{
          style,
          className: classnames(
            // classes.textFieldContainer,
            // { [classes.fullWidth]: fullWidth },
            className
          ),
          id: id ? `${id}-container` : undefined,
          ...containerProps
        }}
        validators={validators}
        classes={classesProp}
        variant={variant || 'outlined'}
        className={classnames(classes.textField, textFieldClassNames)}
        onKeyDown={(e) => {
          if (e.keyCode == 13 && !other.multiline) {
            e.preventDefault();
            e.stopPropagation();
            onEnterKey && onEnterKey();
          }
        }}
        InputLabelProps={{
          required: (validators && validators.indexOf('required') !== -1) || false,
          shrink: true,
          classes: {
            root: classnames(classes.inputLabel, inputLabelClasses)
          }
        }}
        InputProps={{
          readOnly,
          classes: inputClasses,
          ...InputProps
        }}
        inputProps={{
          ...inputProps
        }}
        {...other}
      />
    );
  }
}

TextField.propTypes = {
  classes: object,
  classesProp: object,
  inputClasses: object,
  containerProps: object,
  className: string,
  inputLabelClasses: string,
  textFieldClassNames: string,
  id: string,
  variant: string,
  readOnly: bool,
  onEnterKey: func,
  inputProps: object,
  InputProps: object,
  theme: object,
  style: object,
  validators: array,
  fullWidth: bool
};

export default withStyles(styles, { withTheme: true })(TextField);
